import React from "react";
import "../Styles/SeventhSection.css";
import backgroundImage from "../Assets/Happy_Client.jpg"; // replace with your image path

const SeventhSection = () => {
  return (
    <section
      className="background-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Optional overlay */}
      <div className="overlay"></div>
      {/* You can add content here if needed */}
    </section>
  );
};

export default SeventhSection;
